import * as React from "react";
import classnames from "classnames";
import { PrescriptionInformationLink } from "../../../../../../../../PrescriptionInformationLink/steps/components/PrescriptionInformationLink/PrescriptionInformationLink.js";
/* empty css                                   */
const PupillaryDistanceExternalLink = ({ className, pdLinkLabel }) => {
  return /* @__PURE__ */ React.createElement(
    PrescriptionInformationLink,
    {
      className: classnames("pupillary-distance-external-link", className)
    },
    pdLinkLabel
  );
};
export {
  PupillaryDistanceExternalLink
};
//# sourceMappingURL=PupillaryDistanceExternalLink.js.map
